<template>
  <v-dialog v-model="showNewNbnTicket" width="1200" persistent>
    <v-card>
      <v-banner sticky class="primary custom-padding py-0">
        <v-row class="text-left pb-0">
          <v-col cols="12" md="3" lg="2" class="py-0 pt-5">
            <span class="white--text custom-title">Create NBN Ticket</span>
          </v-col>
          <v-col cols="12" md="4" lg="4" class="pb-0">
            <ValidationProvider
              name="Wholesaler"
              rules="required"
              v-slot="{ errors }"
            >
              <v-autocomplete
                :items="wholesalerData"
                label="Wholesaler"
                outlined
                placeholder="Select wholesaler"
                :error-messages="
                  wholesalerAccount === 0 ? 'Wholesaler is required' : errors
                "
                :error="wholesalerAccount === 0"
                :item-text="setCompany"
                item-value="accountNumber"
                dense
                dark
                v-model="wholesalerAccount"
                :readonly="wholesalerData.length === 1"
                :disabled="isOriginal"
                @change="wholesalerChanged"
              ></v-autocomplete>
            </ValidationProvider>
            <v-spacer></v-spacer>
          </v-col>
        </v-row>
      </v-banner>
      <v-divider class="mt-4 mb-8"></v-divider>
      <v-card-text>
        <nbn-ticket-details ref="ticketDetail" :ticket="ticket" :fromOrderView="fromOrderView" :technologyType="technologyType"></nbn-ticket-details>
        <div class="fixed-bar  py-4 text-right">
          <v-btn @click="create()" class="mr-4" :disabled="checkSubmit">Create</v-btn>
          <v-btn @click="close()" class="mr-4">Close</v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "nbn-ticket-form",
  props: {
    showNewNbnTicket: { type: Boolean, required: true },
    fromOrderView: { type: Boolean, required: true },
    technologyType: { type: String, required: false },
    nbnOrderId: { type: String, required: false },
  },
  data: () => ({
    ticket:{},
    wholesalerAccount: 0
  }),
  methods: {
    close(){
      let vm =this;
      vm.ticket = {};
      vm.$emit("closeDialog");
    },
    checkLayer() {
      const vm = this;

      if(vm.wholesalerData.length === 1){
        vm.retrieveFeatures(vm.wholesalers[0].accountNumber);
      } else {
        vm.retrieveFeatures(vm.wholesalerAccount);
      }
    },
    setCompany(details) {
      let text = "";
      if (details.company !== "" && details.company !== null)
        text = details.company;
      else if (details.name !== "" && details.name !== null)
        text = details.name;
      return text;
    },
    wholesalerChanged() {
      let vm = this;
      vm.getUBCustomers({ id: vm.wholesalerAccount, keyword: "all" });
      vm.checkLayer();
    },
    create(){
      let vm =this;
      let ticket = {
        "category":vm.ticket.category,
        "ticketType":vm.ticket.ticketType,
        "severity":vm.ticket.severity,
        "externalId":vm.ticket.externalId,
        "description":vm.ticket.description
      };
      if(vm.ticket.subCategory != null && vm.ticket.subCategory !== "")
      {
        ticket.subCategory = vm.ticket.subCategory;
      }

      if(vm.ticket.locationId != null && vm.ticket.locationId !== "")
      {
        ticket.relatedPlace = {
          "id":vm.ticket.locationId
        }
      }

      if(vm.ticket.orderId != null && vm.ticket.orderId !== "")
      {
        ticket.relatedEntityRef = {
          "id":vm.ticket.orderId
        }
      }

      if(vm.ticket.appointmentId != null && vm.ticket.appointmentId !== "")
      {
        ticket.relatedAppointment = {
          "id":vm.ticket.appointmentId
        }
      }

      if(vm.ticket.productId != null && vm.ticket.productId !== "")
      {
        ticket.relatedProduct = {
          "id":vm.ticket.productId
        }
      }


      if(vm.ticket.fnnUllId != null && vm.ticket.fnnUllId !== "" && vm.ticket.fnnUll !== "")
      {
        if(vm.ticket.fnnUll === "Fnn")
        {
          ticket.fnnServiceIdentifier = vm.ticket.fnnUllId;
        } else {
          ticket.ullServiceIdentifier = vm.ticket.fnnUllId;
        }
      }

      if(vm.ticket.expectedSc != null && vm.ticket.expectedSc !== "")
      {
        ticket.expectedServiceabilityClass = vm.ticket.expectedSc;
      }

      if(vm.ticket.returnedSc != null && vm.ticket.returnedSc !== "")
      {
        ticket.serviceabilityClass = vm.ticket.returnedSc;
      }

      if(vm.ticket.streetName != null && vm.ticket.streetName !== "")
      {
        ticket.physicalAddress = {
          "stateTerritoryCode":vm.ticket.state,
          "roadName":vm.ticket.streetName,
          "roadTypeCode":vm.ticket.streetType,
          "localityName":vm.ticket.suburb,
          "roadNumber1":vm.ticket.streetNumber,
        };
      }
      if(vm.ticket.faultLocation != null && vm.ticket.faultLocation !== "")
      {
        ticket.endUserEngagementType = vm.ticket.faultLocation;
      }

      if(vm.ticket.contactGivenName != null && vm.ticket.contactGivenName !== "")
      {
        ticket["relatedContact"] = {
          "contactName":vm.ticket.contactGivenName?vm.ticket.contactGivenName:"",
          // "lastName":vm.ticket.contactFamilyName?vm.ticket.contactFamilyName:"",
          "contactType":"Technician",
          "phoneNumber":vm.ticket.contactNumber?vm.ticket.contactNumber:"",
        }
      }

      if(vm.ticket.ticketType == "Service Restoration" && vm.ticket.technologyType == "FTTC")
      {
        ticket.endUserEngagementType = "Appointment";
      }

      let checlist = vm.getCheckList();
      if(checlist.completed != null && checlist.completed =="Yes")
      {
        ticket.checklist = checlist;
      }


      let payload = {"Ticket": ticket, "WholesalerAccount":vm.wholesalerAccount};
      if(vm.fromOrderView)
      {
        payload.NbnOrderId = vm.nbnOrderId;
      }
      vm.createNewTicket(payload).then(() => {
      });
      vm.$emit("closeDialog");
    },
    getCheckList(){
      let vm =this;
      let content = "";
      let id="";
      let version = "";
      let specificationType = "TestAndDiagnostic Checklist Specification";
      let checklist = {};
      content = vm.addCheck(content, vm.ticket.cpePowercycled, 'Is CPE Power Cycled');
      content = vm.addCheck(content, vm.ticket.cpeAlternateTest, 'Is Alternate CPE Tested');
      content = vm.addCheck(content, vm.ticket.incidents, 'Is Any Active Incidents At Time Of Fault');
      content = vm.addCheck(content, vm.ticket.isolationTest, 'Is Isolation Test Run');
      if(vm.ticket.technologyType == 'Fibre')
      {
        content = vm.addCheck(content, vm.ticket.isolationTest, 'Is Isolation Test Run');
        content = content + vm.getFibreCheckList();
        id="Fibre SRI TestAndDiagnostic Checklist Specification";
        version="1.0.2";
      } else if(vm.ticket.technologyType == 'Fixed Wireless')
      {
        content = vm.addCheck(content, vm.ticket.isolationTest, 'Is Isolation Test Run');
        content = content + vm.getWirelessCheckList();
        id="Wireless SRI TestAndDiagnostic Checklist Specification";
        version="1.0.1";
      } else if(vm.ticket.technologyType == 'HFC')
      {
        content = vm.addCheck(content, vm.ticket.isolationTest, 'Is Isolation Test Run');
        content = content + vm.getHfcCheckList();
        id="HFC SRI TestAndDiagnostic Checklist Specification";
        version="1.0.3";
      } else if(vm.ticket.technologyType == 'FTTC')
      {
        id="Copper SRI TestAndDiagnostic Checklist Specification"
        version= "1.1.0";
        content = content + vm.getFttcCheckList();
      } else if(vm.ticket.technologyType == 'FTTN' || vm.ticket.technologyType == 'FTTB')
      {
        id="Copper SRI TestAndDiagnostic Checklist Specification"
        version= "1.1.0";
        content = content + vm.getFttnFttbCheckList();
      }

      if(content != "")
      {
        checklist.completed = "Yes";
        checklist.content = content;
        checklist.checklistSpecification = {
          "id":id,
          "version":version,
          "specificationType":specificationType
        }
      }
      return checklist;
    },
    getFibreCheckList(){
      let vm =this;
      let content = "";
      content = vm.addCheck(content, vm.ticket.ntdSerialNumber, 'NTD Serial Number');
      content = vm.addCheck(content, vm.ticket.cpeName, 'CPE Type');
      content = vm.addCheck(content, vm.ticket.cpeMac, 'CPE MAC Address');
      content = vm.addCheck(content, vm.ticket.fibreDamaged, 'Is Fibre Lead Damaged');
      content = vm.addCheck(content, vm.ticket.powerStatus, 'Power Status');
      content = vm.addCheck(content, vm.ticket.powerBehaviour, 'Power Behaviour');
      content = vm.addCheck(content, vm.ticket.opticalStatus, 'Optical Status');
      content = vm.addCheck(content, vm.ticket.opticalBehaviour, 'Optical Behaviour');
      content = vm.addCheck(content, vm.ticket.alarmStatus, 'Alarm Status');
      content = vm.addCheck(content, vm.ticket.alarmBehaviour, 'Alarm Behaviour');
      content = vm.addCheck(content, vm.ticket.unidStatus, 'UNI-D Status');
      content = vm.addCheck(content, vm.ticket.unidBehaviour, 'UNI-D Behaviour');
      content = vm.addCheck(content, vm.ticket.univStatus, 'UNI-V Status');
      content = vm.addCheck(content, vm.ticket.univBehaviour, 'UNI-V Behaviour');
      content = vm.addCheck(content, vm.ticket.unidStatus, 'UNI-D Status');
      content = vm.addCheck(content, vm.ticket.unidBehaviour, 'UNI-D Behaviour');
      content = vm.addCheck(content, vm.ticket.univStatus, 'Update Status');
      content = vm.addCheck(content, vm.ticket.univBehaviour, 'Update Behaviour');
      content = vm.addCheck(content, vm.ticket.usedPort, 'Ports Used');
      return content;
    },
    getWirelessCheckList(){
      let vm =this;
      let content = "";
      content = vm.addCheck(content, vm.ticket.ntdSerialNumber, 'NTD Serial Number');
      content = vm.addCheck(content, vm.ticket.cpeName, 'CPE Type');
      content = vm.addCheck(content, vm.ticket.cpeMac, 'CPE MAC Address');
      content = vm.addCheck(content, vm.ticket.powerStatus, 'Power Status');
      content = vm.addCheck(content, vm.ticket.powerBehaviour, 'Power Behaviour');
      content = vm.addCheck(content, vm.ticket.statusStatus, 'LED Status');
      content = vm.addCheck(content, vm.ticket.statusBehaviour, 'LED Behaviour');
      content = vm.addCheck(content, vm.ticket.oduStatus, 'ODU Status');
      content = vm.addCheck(content, vm.ticket.oduBehaviour, 'ODU Behaviour');
      content = vm.addCheck(content, vm.ticket.unidStatus, 'UNI-D Status');
      content = vm.addCheck(content, vm.ticket.unidBehaviour, 'UNI-D Behaviour');
      content = vm.addCheck(content, vm.ticket.signalStrengthStatus, 'Signal Strength Status');
      content = vm.addCheck(content, vm.ticket.usedPort, 'Ports Used');
      return content;
    },
    getHfcCheckList(){
      let vm =this;
      let content = "";
      content = vm.addCheck(content, vm.ticket.ntdSerialNumber, 'NTD Serial Number');
      content = vm.addCheck(content, vm.ticket.ntdType, 'CPE Modem Number');
      content = vm.addCheck(content, vm.ticket.ntdPowerStatus, 'Power Status');
      content = vm.addCheck(content, vm.ticket.ntdDsStatus, 'DS Status');
      content = vm.addCheck(content, vm.ticket.ntdUsStatus, 'US Status');
      content = vm.addCheck(content, vm.ticket.ntdOnlineStatus, 'Online Status');
      content = vm.addCheck(content, vm.ticket.ntdLinkStatus, 'Link Status');
      content = vm.addCheck(content, vm.ticket.homeAmplifierInstalled, 'Is there an In Home Amplifier already installed at the premises');
      content = vm.addCheck(content, vm.ticket.homeAmplifierInstalledPower, 'Is The In Home Amplifier Turned On');
      return content;
    },
    getFttcCheckList(){
      let vm =this;
      let content = "";
      content = vm.addCheck(content, vm.ticket.ntdSerialNumber, 'NTD Serial Number');
      content = vm.addCheck(content, vm.ticket.ntdType, 'CPE Modem Number');
      content = vm.addCheck(content, vm.ticket.powerStatus, 'Power Status');
      content = vm.addCheck(content, vm.ticket.powerBehaviour, 'Power Behaviour');
      content = vm.addCheck(content, vm.ticket.linkStatus, 'Link Status');
      content = vm.addCheck(content, vm.ticket.linkBehaviour, 'Link Behaviour');
      content = vm.addCheck(content, vm.ticket.dslStatus, 'DSL Status');
      content = vm.addCheck(content, vm.ticket.dslBehaviour, 'DSL Behaviour');
      content = vm.addCheck(content, vm.ticket.lanStatus, 'LAN Status');
      content = vm.addCheck(content, vm.ticket.lanBehaviour, 'LAN Behaviour');
      content = vm.addCheck(content, vm.ticket.cablesChecked, 'Have the cables been checked');
      content = vm.addCheck(content, vm.ticket.ncdConnected, 'Is the NCD connected to the first socket');
      content = vm.addCheck(content, vm.ticket.serviceWorked, 'Has the service ever worked');
      content = vm.addCheck(content, vm.ticket.ncdMac, 'NCD MAC Address');
      content = vm.addCheck(content, vm.ticket.issueExistOutsidePeak, 'Does the issue exist outside of peak time');
      content = vm.addCheck(content, vm.ticket.cvcNotCongested, 'Have you confirmed that the CVC is not congested');
      return content;
    },
    getFttnFttbCheckList(){
      let vm =this;
      let content = "";
      content = vm.addCheck(content, vm.ticket.powerStatus, 'Power Status');
      content = vm.addCheck(content, vm.ticket.powerBehaviour, 'Power Behaviour');
      content = vm.addCheck(content, vm.ticket.dslStatus, 'DSL/Sync Status');
      content = vm.addCheck(content, vm.ticket.dslBehaviour, 'DSL/Sync Status Behaviour');
      content = vm.addCheck(content, vm.ticket.internetStatus, 'Internet Status');
      content = vm.addCheck(content, vm.ticket.internetBehaviour, 'Internet Behaviour');
      content = vm.addCheck(content, vm.ticket.modemModel, 'CPE Modem Model');
      content = vm.addCheck(content, vm.ticket.modemNumber, 'CPE Model Number');
      content = vm.addCheck(content, vm.ticket.numberOfPhoneSockets, 'Number Of Phone Sockets');
      content = vm.addCheck(content, vm.ticket.voiceServicePresent, 'Is Exchange Based Voice Service Present');
      content = vm.addCheck(content, vm.ticket.centralSplitterInstalled, 'Is Central Splitter Installed');
      content = vm.addCheck(content, vm.ticket.alternateCableTested, 'Is Alternate Phone Cable Tested');
      return content;
    },
    addCheck(content, check, checkName)
    {
      if(check != null && check != "")
      {
        content = content + checkName + ' - ' + check + '\\n';
      }
      return content;
    },
    setWholesaler(wholesalerValue) {
      let vm = this;
      if(wholesalerValue != null)
      {
        vm.wholesalerAccount = wholesalerValue;
      } else {
        vm.getWholesalers()
          .then((data) => {
            if (!vm.isUserMember || data.length === 1) {
              vm.selectedWholeSaler = data[0];
              if(vm.selectedWholeSaler.is_radius_user === "n")
              {
                const columnIndex = vm.$parent.columnDefs.findIndex(column => column.field === "radiusStatus");
                if (columnIndex !== -1) {
                  vm.$parent.columnDefs.splice(columnIndex, 1);
                  // Optionally, you can force the grid to refresh to apply the changes
                  // vm.$refs.agGrid.api.setColumnDefs(this.columnDefs);
                  // vm.$refs.agGrid.api.refreshHeader();
                }
              }
            } else if(wholesalerValue != null) {
              vm.selectedWholeSaler = data.find( x=> x.accountNumber === wholesalerValue);
            } else vm.selectedWholeSaler = null;
          })
          .catch(() => {});
      }
    },
  },
  computed: {
    wholesalerData: function () {
      let vm = this;
      let data = null;

      if (vm.impersonating !== null) {
        if (vm.isUserMember) {
          data = vm.wholesalers;
          if(!vm.isOriginal){
            if(vm.wholesalers.length > 1)
              vm.wholesalerAccount = 0;
            else {
              vm.wholesalerAccount = vm.wholesalers[0].accountNumber;
            }
          }
        } else {
          // data = vm.wholesalers.filter(
          //   (x) => x.oneLoginEmail === vm.user.email
          // );
          data = vm.wholesalers.filter(
            (x) => x.oneLoginEmail === vm.impersonating.impersonateEmail
          );
          vm.selectedWholeSaler = data[0];
        }
      } else {
        if (vm.isAdmin) {
          data = vm.wholesalers;

          if (vm.isOriginal)
            vm.selectedWholeSaler = vm.wholesalers.filter(
              (x) =>
                x.accountNumber === vm.selectedOrder.wholesalerAccountNumber
            ).wholesalerAccountNumber;
          else vm.selectedWholeSaler = null;
        } else {
          data = vm.wholesalers.filter(
            (x) => x.oneLoginEmail === vm.user.email
          );
          vm.selectedWholeSaler = data[0];
        }
      }

      return data;
    },
    checkSubmit() {
      let vm = this;

      if(vm.wholesalerAccount == null || vm.wholesalerAccount <= 0)
      {
        return true;
      }

      if(vm.ticket.category == null || vm.ticket.ticketType == null || vm.ticket.severity == null || vm.ticket.externalId == null || vm.ticket.description == null)
      {
        return true;
      }

      if(vm.ticket.ticketType == "Service Restoration" && (vm.ticket.technologyType == "FTTC" || vm.ticket.endUserEngagementType == "Appointment") && vm.ticket.appointmentId == null)
      {
        return true;
      }

      if(vm.ticket.ticketType == 'Service Request' && vm.ticket.category != 'FNN/ULL Dispute' && vm.ticket.category != 'Technology Enquiry' && vm.ticket.subCategory == null)
      {
        return true;
      }

      return false;
    }
  }
}
</script>

<style scoped>

</style>
